/* EComposer may redraw labels and prices after a variant change. */
(() => {
  const root = document.getElementById('ecom-pagina-de-producto');
  if (!root || root.dataset.dripProductReady) return;
  root.dataset.dripProductReady = 'true';
  const tidy = () => {
    root.querySelectorAll('.ecom-product-variant--option-label-text').forEach(label => {
      if (/^(size|taille)\s*:?$/i.test(label.textContent.trim())) label.textContent = 'Talla';
    });
    root.querySelectorAll('.ecom-3ruv6ls6mnq .ecom-product-single__price--sale, .ecom-3ruv6ls6mnq .ecom-product-single__price--regular').forEach(price => {
      for (const node of price.childNodes) {
        if (node.nodeType === Node.TEXT_NODE && /\sEUR\b/.test(node.textContent)) node.textContent = node.textContent.replace(/\sEUR\b/g, '');
      }
    });
  };
  tidy();
  const details = root.querySelector('.ecom-6snjshxdpx4');
  if (details) new MutationObserver(tidy).observe(details, {childList:true,subtree:true,characterData:true});
})();
